var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
import { Button } from "../Button";
const defaultProps = {
    "data-testid": "tecma-header-menu-item",
};
const MenuItemItem = (_a) => {
    var { children, id, style, className, iconName, title, subtitle, onClick } = _a, rest = __rest(_a, ["children", "id", "style", "className", "iconName", "title", "subtitle", "onClick"]);
    const classList = classNames("tecma-header-menu-item", className);
    return (_jsx("li", Object.assign({ id: id, style: style, className: classList }, rest, { children: onClick ? (_jsxs(Button, { onClick: onClick, fluid: true, color: "transparent", iconName: iconName, children: [_jsx("span", { className: "menu-item-title", children: title }), _jsx("span", { className: "menu-item-subtitle", children: subtitle })] })) : (_jsxs("div", { className: "not-clickable-item", children: [_jsx("span", { className: "menu-item-title", children: title }), _jsx("span", { className: "menu-item-subtitle", children: subtitle })] })) })));
};
MenuItemItem.defaultProps = defaultProps;
export default memo(MenuItemItem);
